import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import { Segment, Form, Checkbox, Button, Icon, Modal, Header, Radio } from "semantic-ui-react";
import MediaItemDownloadInfo from "~/models/Media/MediaItemDownloadInfo";

const MediaDownloadCheckbox = observer(({ mediaItemDownloadInfo, checked }) => {
  const name = `mediaKitManifest[${mediaItemDownloadInfo.className}][${mediaItemDownloadInfo.mediaItemId}][${mediaItemDownloadInfo.size}]`;
  return <input type="checkbox" name={name} checked={Boolean(checked)} readOnly value="on" />;
});

@observer
class BulkDownload extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showZipDownloadSuccess: false,
    };
  }

  onDownloadZipSubmit() {
    this.setState({ showZipDownloadSuccess: true });
  }

  render() {
    const {
      zipDownloadUrl,
      smallPhotos,
      largePhotos,
      mlsPhotos,
      printQualityPhotos,
      smallVirtualTours,
      largeVirtualTours,
      smallVideoClips,
      largeVideoClips,
      fhdVideoClips,
      hasPhotos,
      hasVirtualTours,
      hasVideoClips,
      downloadSize,
      filesSelectedCount,
      zipFilename,
      setProperty,
      model,
      t,
    } = this.props;
    const { showZipDownloadSuccess } = this.state;

    return (
      <>
        <Modal open={showZipDownloadSuccess} onClose={() => this.setState({ showZipDownloadSuccess: false })}>
          <Modal.Header>{t("clientPanelDownload:yourDownloadStarted")}</Modal.Header>
          <Modal.Content>
            <Modal.Description>
              <Header>{t("clientPanelDownload:openDownloadedFile")}</Header>
              <p>
                {t("clientPanelDownload:clickOn")} &quot;{zipFilename}&quot; {t("clientPanelDownload:atBottomBrowser")}
              </p>
            </Modal.Description>
          </Modal.Content>
          <Modal.Actions>
            <Button basic color="blue" onClick={() => this.setState({ showZipDownloadSuccess: false })}>
              <Icon name="close" /> {t("ok")}
            </Button>
          </Modal.Actions>
        </Modal>
        <Segment className="bulk-download">
          <h3>{t("clientPanelDownload:bulkMediaDownload")}</h3>
          <p>
            {t("clientPanelDownload:downloadAllMediaFiles")}
            <br />
            {t("clientPanelDownload:imageDimensionsSmallLargeApprox")}
          </p>
          <Form.Field
            control={Radio}
            toggle
            label={t("clientPanelDownload:useShortFilename")}
            checked={model.useShortFilenamesChecked}
            onChange={() => setProperty("useShortFilenamesChecked", !model.useShortFilenamesChecked)}
          />
          {hasPhotos ? (
            <Segment>
              <h3>{t("clientPanelDownload:photos")}</h3>
              <Form>
                <Form.Field
                  control={Checkbox}
                  label={t("clientPanelDownload:allSmallLengthImages", { smallPhotosLength: smallPhotos.length })}
                  checked={model.smallPhotosChecked}
                  onChange={() => setProperty("smallPhotosChecked", !model.smallPhotosChecked)}
                />
                <Form.Field
                  control={Checkbox}
                  label={t("clientPanelDownload:allLargeLengthImages", { largePhotosLength: largePhotos.length })}
                  checked={model.largePhotosChecked}
                  onChange={() => setProperty("largePhotosChecked", !model.largePhotosChecked)}
                />
                {mlsPhotos.length > 0 && (
                  <Form.Field
                    control={Checkbox}
                    label={t("clientPanelDownload:allMLSLengthImages", { mlsPhotosLength: mlsPhotos.length })}
                    checked={model.mlsPhotosChecked}
                    onChange={() => setProperty("mlsPhotosChecked", !model.mlsPhotosChecked)}
                  />
                )}
                {printQualityPhotos.length > 0 && (
                  <Form.Field
                    control={Checkbox}
                    label={t("clientPanelDownload:allPrintQualityLengthImages", {
                      printQualityPhotosLength: printQualityPhotos.length,
                    })}
                    checked={model.printQualityPhotosChecked}
                    onChange={() => setProperty("printQualityPhotosChecked", !model.printQualityPhotosChecked)}
                  />
                )}
              </Form>
            </Segment>
          ) : (
            <div className="gutter" />
          )}
          {hasVirtualTours && (
            <Segment>
              <h3>{t("clientPanelDownload:panoramas")}</h3>
              <Form>
                <Form.Field
                  control={Checkbox}
                  label={t("clientPanelDownload:allSmallVirtualToursLengthImages", {
                    smallVirtualToursLength: smallVirtualTours.length,
                  })}
                  checked={model.smallVirtualToursChecked}
                  onChange={() => setProperty("smallVirtualToursChecked", !model.smallVirtualToursChecked)}
                />
                <Form.Field
                  control={Checkbox}
                  label={t("clientPanelDownload:allLargeVirtualToursLengthImages", {
                    largeVirtualToursLength: largeVirtualTours.length,
                  })}
                  checked={model.largeVirtualToursChecked}
                  onChange={() => setProperty("largeVirtualToursChecked", !model.largeVirtualToursChecked)}
                />
              </Form>
            </Segment>
          )}
          {hasVideoClips && (
            <Segment>
              <h3>{t("clientPanelDownload:videoClips")}</h3>
              <Form>
                <Form.Field
                  control={Checkbox}
                  label={t("clientPanelDownload:allSmallVideoClipsLengthVideos", {
                    smallVideoClipsLength: smallVideoClips.length,
                  })}
                  checked={model.smallVideoClipsChecked}
                  onChange={() => setProperty("smallVideoClipsChecked", !model.smallVideoClipsChecked)}
                />
                <Form.Field
                  control={Checkbox}
                  label={t("clientPanelDownload:allLargeVideoClipsLengthVideos", {
                    largeVideoClipsLength: largeVideoClips.length,
                  })}
                  checked={model.largeVideoClipsChecked}
                  onChange={() => setProperty("largeVideoClipsChecked", !model.largeVideoClipsChecked)}
                />
                {fhdVideoClips.length > 0 && (
                  <Form.Field
                    control={Checkbox}
                    label={t("clientPanelDownload:all1080PVideoClipsLengthVideos", {
                      fhdVideoClipsLength: fhdVideoClips.length,
                    })}
                    checked={model.fhdVideoClipsChecked}
                    onChange={() => setProperty("fhdVideoClipsChecked", !model.fhdVideoClipsChecked)}
                  />
                )}
              </Form>
            </Segment>
          )}
          <Form id="download-form" action={zipDownloadUrl} method="post" onSubmit={() => this.onDownloadZipSubmit()}>
            <input hidden name="useShortFilename" value={model.useShortFilenamesChecked ? "1" : ""} readOnly />
            {smallPhotos.map(mediaItemDownloadInfo => (
              <MediaDownloadCheckbox
                key={mediaItemDownloadInfo.uuid}
                mediaItemDownloadInfo={mediaItemDownloadInfo}
                checked={model.smallPhotosChecked}
              />
            ))}
            {largePhotos.map(mediaItemDownloadInfo => (
              <MediaDownloadCheckbox
                key={mediaItemDownloadInfo.uuid}
                mediaItemDownloadInfo={mediaItemDownloadInfo}
                checked={model.largePhotosChecked}
              />
            ))}
            {mlsPhotos.map(mediaItemDownloadInfo => (
              <MediaDownloadCheckbox
                key={mediaItemDownloadInfo.uuid}
                mediaItemDownloadInfo={mediaItemDownloadInfo}
                checked={model.mlsPhotosChecked}
              />
            ))}
            {printQualityPhotos.map(mediaItemDownloadInfo => (
              <MediaDownloadCheckbox
                key={mediaItemDownloadInfo.uuid}
                mediaItemDownloadInfo={mediaItemDownloadInfo}
                checked={model.printQualityPhotosChecked}
              />
            ))}
            {smallVirtualTours.map(mediaItemDownloadInfo => (
              <MediaDownloadCheckbox
                key={mediaItemDownloadInfo.uuid}
                mediaItemDownloadInfo={mediaItemDownloadInfo}
                checked={model.smallVirtualToursChecked}
              />
            ))}
            {largeVirtualTours.map(mediaItemDownloadInfo => (
              <MediaDownloadCheckbox
                key={mediaItemDownloadInfo.uuid}
                mediaItemDownloadInfo={mediaItemDownloadInfo}
                checked={model.largeVirtualToursChecked}
              />
            ))}
            {smallVideoClips.map(mediaItemDownloadInfo => (
              <MediaDownloadCheckbox
                key={mediaItemDownloadInfo.uuid}
                mediaItemDownloadInfo={mediaItemDownloadInfo}
                checked={model.smallVideoClipsChecked}
              />
            ))}
            {largeVideoClips.map(mediaItemDownloadInfo => (
              <MediaDownloadCheckbox
                key={mediaItemDownloadInfo.uuid}
                mediaItemDownloadInfo={mediaItemDownloadInfo}
                checked={model.largeVideoClipsChecked}
              />
            ))}
            {fhdVideoClips.map(mediaItemDownloadInfo => (
              <MediaDownloadCheckbox
                key={mediaItemDownloadInfo.uuid}
                mediaItemDownloadInfo={mediaItemDownloadInfo}
                checked={model.fhdVideoClipsChecked}
              />
            ))}
            <Button type="submit" disabled={filesSelectedCount === 0} primary icon>
              <Icon name="download" />
              &nbsp;{t("clientPanelDownload:downloadAllMedia")}
            </Button>
            &nbsp;
            <a href="#individual-download">{t("clientPanelDownload:downloadIndividualFiles")}</a>
            <p>
              {filesSelectedCount} {t("clientPanelDownload:files")}, {downloadSize} {t("clientPanelDownload:megabytes")}
            </p>
          </Form>
        </Segment>
      </>
    );
  }
}

BulkDownload.propTypes = {
  // media stuff
  // arrays
  smallPhotos: PropTypes.arrayOf(PropTypes.instanceOf(MediaItemDownloadInfo)),
  largePhotos: PropTypes.arrayOf(PropTypes.instanceOf(MediaItemDownloadInfo)),
  mlsPhotos: PropTypes.arrayOf(PropTypes.instanceOf(MediaItemDownloadInfo)),
  printQualityPhotos: PropTypes.arrayOf(PropTypes.instanceOf(MediaItemDownloadInfo)),
  smallVirtualTours: PropTypes.arrayOf(PropTypes.instanceOf(MediaItemDownloadInfo)),
  largeVirtualTours: PropTypes.arrayOf(PropTypes.instanceOf(MediaItemDownloadInfo)),
  smallVideoClips: PropTypes.arrayOf(PropTypes.instanceOf(MediaItemDownloadInfo)),
  largeVideoClips: PropTypes.arrayOf(PropTypes.instanceOf(MediaItemDownloadInfo)),
  fhdVideoClips: PropTypes.arrayOf(PropTypes.instanceOf(MediaItemDownloadInfo)),
  // booleans
  hasPhotos: PropTypes.bool,
  hasVirtualTours: PropTypes.bool,
  hasVideoClips: PropTypes.bool,
  // extra info
  zipDownloadUrl: PropTypes.string.isRequired,
  downloadSize: PropTypes.number.isRequired,
  filesSelectedCount: PropTypes.number.isRequired,
  zipFilename: PropTypes.string.isRequired,
  // Form stuff
  model: PropTypes.shape({
    smallPhotosChecked: PropTypes.bool,
    largePhotosChecked: PropTypes.bool,
    mlsPhotosChecked: PropTypes.bool,
    printQualityPhotosChecked: PropTypes.bool,
    smallVirtualToursChecked: PropTypes.bool,
    largeVirtualToursChecked: PropTypes.bool,
    smallVideoClipsChecked: PropTypes.bool,
    largeVideoClipsChecked: PropTypes.bool,
    fhdVideoClipsChecked: PropTypes.bool,
    useShortFilenamesChecked: PropTypes.bool,
  }),
  setProperty: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(BulkDownload);
